import { ArgsType } from '@nestjs/graphql'
import { BaseGetByIdArgs } from '../../base/baseGetById.args'

@ArgsType()
export class MessageThreadGetByIdArgs extends BaseGetByIdArgs<MessageThreadGetByIdArgs> { }
